// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveExternalInstitutionDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ExternalInstitutionDTO from '../models/ExternalInstitutionDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    externalInstitutionId: number;
    externalInstitution: ExternalInstitutionDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            externalInstitutionId: 0,
            externalInstitution: null,
        },
        initValues);
    },
    externalInstitutionId: 'externalInstitutionId',
    externalInstitution: 'externalInstitution',
}

interface Result extends ResultDTO {
    externalInstitution: ExternalInstitutionDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            externalInstitution: null,
        },
        initValues);
    },
    externalInstitution: 'externalInstitution',
}

export { Request, Result };